import { render, staticRenderFns } from "./amountReason.vue?vue&type=template&id=5cf9a238"
import script from "./amountReason.vue?vue&type=script&lang=js"
export * from "./amountReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports